import { get } from 'lodash';

let configService = $window => {
    return {
        load: () => { return Promise.resolve(); },
        get: key => get($window.config, key)
    };
};

configService.$inject = ['$window'];

export default configService;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/base/services/config.service.js